module.exports = __webpack_public_path__ + "img/brm6.47b37d84.jpg";